<div class="wrapper">
  <div class="container-fluid">

    <!-- start page title -->
    <div class="row">
      <div class="col-12">
        <div class="page-title-box">
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <!-- <li class="breadcrumb-item"><a href="javascript: void(0);">Home</a></li> -->
              <li class="breadcrumb-item active">Bank process report detail</li>
            </ol>
          </div>
          <h4 class="page-title">Bank Process Report Detail</h4>
        </div>
      </div>
    </div>
    <!-- end page title -->


    <div class="row">
      <div class="col-12">

        <div class="card-box">
          <h4 class="header-title">Report Detail</h4>
          <form class="form-horizontal" role="form" autocomplete="off">

            <div class="row">
              <div class="form-group" *ngIf="raiseWarning" style="width:100%;">
                <div class="col-md-12 form-horizontal px-6" style="width:100%;">
                  <ngb-alert [dismissible]="false" style="width:100%;">
                    <strong>Warning!</strong> {{warning}}
                  </ngb-alert>
                </div>
              </div>

              <div class="form-group" *ngIf="raiseDanger" style="width:100%;">
                <div class="col-md-12 form-horizontal px-6" style="width:100%;">
                  <ngb-alert type="danger" [dismissible]="false" style="width:100%;">
                    <strong>Error!</strong> {{danger}}
                  </ngb-alert>
                </div>
              </div>
            </div>
            <div class="row form-horizontal">
              <div class="col-md-6 form-horizontal px-3">

                <div class="form-group row border-bottom my-3">
                  <label class="col-3 col-form-label font-weight-bold">Select date range</label>
                </div>

                <div class="form-group row">
                  <label class="col-2 col-form-label">Start date</label>
                  <div class="col-4">
                    <input class="form-control" type="date" name="startSate" [(ngModel)]="startDate" [ngModelOptions]="{standalone: true}">
                  </div>
                  <label class="col-2 col-form-label">End date</label>
                  <div class="col-4">
                    <input class="form-control" type="date" name="endDate" [(ngModel)]="endDate" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
                <div class="form-group row" *ngIf="!hasMultipleUSNNumbers">

                  <div class="col-2">
                    <button type="submit" *ngIf="!!hasData" class="btn btn-info waves-effect waves-light float-left" (click)="reset()">
                      <i class="mdi mdi-recycle"></i> Reset 
                    </button>
                  </div>
                  <div class="col-10">
                    <button type="submit" *ngIf="!hasData" class="btn btn-info waves-effect waves-light float-right m-2" (click)="submit()">
                      View <i class="mdi mdi-content-save"></i>
                    </button>
                  </div>
                </div>

              </div>
              <div class="col-md-6 form-horizontal px-3" *ngIf="hasMultipleUSNNumbers">

                <div class="form-group row border-bottom my-3">
                  <label class="col-3 col-form-label font-weight-bold">Select a merchant </label>
                </div>

                <div class="form-group row">
                  <label class="col-3 col-form-label">Select a Merchant</label>
                  <div class="col-5">
                    <ng-select bindLabel="merchant" style="width: 100%;" [(ngModel)]="selectedMerchant" [ngModelOptions]="{standalone: true}" [clearable]="false" [searchable]="true">
                      <ng-option [value]="merchant.usnNumber" *ngFor="let merchant of merchants">
                        {{merchant.usnNumber}}
                      </ng-option>
                    </ng-select>
                  </div>
                  <div class="col-2">
                    <button type="submit" *ngIf="!hasData" class="btn btn-info waves-effect waves-light float-left" (click)="submit()">
                      View <i class="mdi mdi-content-save"></i>
                    </button>
                  </div>
                  <div class="col-2">
                    <button type="submit" *ngIf="!!hasData" class="btn btn-info waves-effect waves-light float-left" (click)="reset()">
                      <i class="mdi mdi-recycle"></i> Reset
                    </button>
                  </div>
                </div>

              </div>
            </div>

            <div class="row form-horizontal">
              <div class="form-group row" *ngIf="raiseNoData">
                <div class="col-md-12 form-horizontal px-3">
                  <ngb-alert [dismissible]="false">
                    <strong>{{noData}}</strong>
                  </ngb-alert>
                </div>
              </div>
            </div>

            <div class='bankTransactions' id="DIV_bankTransactions"></div>

            <div class="row" *ngIf="hasData">
              <div class="col-12">
                <button type="button" class="btn btn-icon waves-effect waves-light btn-outline-primary mb-1 float-right" (click)="exportToExel();"> Export to xlsx<i class="mdi mdi-plus"></i> </button>
                &nbsp;
                <button type="button" class="btn btn-icon waves-effect waves-light btn-outline-primary mb-1 float-right" (click)="exportToCSV();"> Export to CSV<i class="mdi mdi-plus"></i> </button>
                &nbsp;
                <button type="button" class="btn btn-icon waves-effect waves-light btn-outline-primary mb-1 float-right" (click)="print();"> Print<i class="mdi mdi-plus"></i> </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div> <!-- end container -->
</div>
